export const MusicAnimation = {
  nm: "03",
  h: 281,
  w: 281,
  meta: { g: "LottieFiles Figma v91" },
  layers: [
    {
      ty: 4,
      nm: "Group 2695",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 1,
          k: [
            {
              o: { x: 0, y: 0.66 },
              i: { x: 0.66, y: 1 },
              s: [57, 62.75],
              t: 0,
            },
            { s: [57, 46.75], t: 75 },
          ],
        },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: {
          a: 1,
          k: [
            {
              o: { x: 0, y: 0.66 },
              i: { x: 0.66, y: 1 },
              s: [135, 121.75],
              t: 0,
            },
            { s: [135, 132.75], t: 75 },
          ],
        },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [],
      ind: 1,
    },
    {
      ty: 4,
      nm: "Ellipse 11",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [9.5, 17.25] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: {
          a: 1,
          k: [
            {
              o: { x: 0, y: 0.66 },
              i: { x: 0.66, y: 1 },
              s: [104.5, 81.25],
              t: 0,
            },
            { s: [104.5, 68.25], t: 75 },
          ],
        },
        r: { a: 0, k: -180 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [-4.647, 0],
                      [0, 0],
                      [0, 0],
                      [0, -6.026],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, -5.02],
                      [0, 0],
                      [0, 0],
                      [-5.847, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [0, 10],
                      [1, 10],
                      [9.5, 1],
                      [9.5, 0],
                      [9.5, -1],
                      [-1, 10],
                      [0, 10],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [-4.65, 0],
                      [0, 0],
                      [0, 0],
                      [0, -6.03],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, -5.02],
                      [0, 0],
                      [0, 0],
                      [-5.85, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [0, 10],
                      [1, 10],
                      [9.5, 1],
                      [9.5, 0],
                      [9.5, -1],
                      [-1, 10],
                      [0, 10],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, -5.02],
                      [0, 0],
                      [0, 0],
                      [5.847, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [4.647, 0],
                      [0, 0],
                      [0, 0],
                      [0, -6.026],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [9.5, 0],
                      [9.5, 1],
                      [18, 10],
                      [19, 10],
                      [20, 10],
                      [9.5, -1],
                      [9.5, 0],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, -5.02],
                      [0, 0],
                      [0, 0],
                      [5.85, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [4.65, 0],
                      [0, 0],
                      [0, 0],
                      [0, -6.03],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [9.5, 0],
                      [9.5, 1],
                      [18, 10],
                      [19, 10],
                      [20, 10],
                      [9.5, -1],
                      [9.5, 0],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 0,
            k: {
              c: true,
              i: [
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
              ],
              o: [
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
              ],
              v: [
                [0, 10],
                [-1, 10],
                [-1, 34.5],
                [0, 34.5],
                [1, 34.5],
                [1, 10],
                [0, 10],
              ],
            },
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0, 0, 0], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 2,
      parent: 1,
    },
    {
      ty: 4,
      nm: "Ellipse 8",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [9.5, 17.25] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: {
          a: 1,
          k: [
            {
              o: { x: 0, y: 0.66 },
              i: { x: 0.66, y: 1 },
              s: [66.5, 108.25],
              t: 0,
            },
            { s: [66.5, 76.25], t: 75 },
          ],
        },
        r: { a: 0, k: -180 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [-4.647, 0],
                      [0, 0],
                      [0, 0],
                      [0, -6.026],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, -5.02],
                      [0, 0],
                      [0, 0],
                      [-5.847, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [0, 10],
                      [1, 10],
                      [9.5, 1],
                      [9.5, 0],
                      [9.5, -1],
                      [-1, 10],
                      [0, 10],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [-4.65, 0],
                      [0, 0],
                      [0, 0],
                      [0, -6.03],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, -5.02],
                      [0, 0],
                      [0, 0],
                      [-5.85, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [0, 10],
                      [1, 10],
                      [9.5, 1],
                      [9.5, 0],
                      [9.5, -1],
                      [-1, 10],
                      [0, 10],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, -5.02],
                      [0, 0],
                      [0, 0],
                      [5.847, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [4.647, 0],
                      [0, 0],
                      [0, 0],
                      [0, -6.026],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [9.5, 0],
                      [9.5, 1],
                      [18, 10],
                      [19, 10],
                      [20, 10],
                      [9.5, -1],
                      [9.5, 0],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, -5.02],
                      [0, 0],
                      [0, 0],
                      [5.85, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [4.65, 0],
                      [0, 0],
                      [0, 0],
                      [0, -6.03],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [9.5, 0],
                      [9.5, 1],
                      [18, 10],
                      [19, 10],
                      [20, 10],
                      [9.5, -1],
                      [9.5, 0],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 0,
            k: {
              c: true,
              i: [
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
              ],
              o: [
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
              ],
              v: [
                [0, 10],
                [-1, 10],
                [-1, 34.5],
                [0, 34.5],
                [1, 34.5],
                [1, 10],
                [0, 10],
              ],
            },
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0, 0, 0], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 3,
      parent: 1,
    },
    {
      ty: 4,
      nm: "Ellipse 7",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [9.5, 39] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: {
          a: 1,
          k: [
            {
              o: { x: 0, y: 0.66 },
              i: { x: 0.66, y: 1 },
              s: [28.5, 59.5],
              t: 0,
            },
            { s: [28.5, 46.5], t: 75 },
          ],
        },
        r: { a: 0, k: -180 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 0,
            k: {
              c: true,
              i: [
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
              ],
              o: [
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
              ],
              v: [
                [0, 10],
                [-1, 10],
                [-1, 10],
                [0, 10],
              ],
            },
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 0,
            k: {
              c: true,
              i: [
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
              ],
              o: [
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
              ],
              v: [
                [19, 10],
                [18, 10],
                [18, 10],
                [19, 10],
              ],
            },
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [-4.647, 0],
                      [0, 0],
                      [0, 0],
                      [0, -6.026],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, -5.02],
                      [0, 0],
                      [0, 0],
                      [-5.847, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [0, 10],
                      [1, 10],
                      [9.5, 1],
                      [9.5, 0],
                      [9.5, -1],
                      [-1, 10],
                      [0, 10],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [-4.65, 0],
                      [0, 0],
                      [0, 0],
                      [0, -6.03],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, -5.02],
                      [0, 0],
                      [0, 0],
                      [-5.85, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [0, 10],
                      [1, 10],
                      [9.5, 1],
                      [9.5, 0],
                      [9.5, -1],
                      [-1, 10],
                      [0, 10],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, -5.02],
                      [0, 0],
                      [0, 0],
                      [5.847, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [4.647, 0],
                      [0, 0],
                      [0, 0],
                      [0, -6.026],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [9.5, 0],
                      [9.5, 1],
                      [18, 10],
                      [19, 10],
                      [20, 10],
                      [9.5, -1],
                      [9.5, 0],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, -5.02],
                      [0, 0],
                      [0, 0],
                      [5.85, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [4.65, 0],
                      [0, 0],
                      [0, 0],
                      [0, -6.03],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [9.5, 0],
                      [9.5, 1],
                      [18, 10],
                      [19, 10],
                      [20, 10],
                      [9.5, -1],
                      [9.5, 0],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [0, 10],
                      [-1, 10],
                      [-1, 78],
                      [0, 78],
                      [1, 78],
                      [1, 10],
                      [0, 10],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [0, 10],
                      [-1, 10],
                      [-1, 78],
                      [0, 78],
                      [1, 78],
                      [1, 10],
                      [0, 10],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [19, 10],
                      [18, 10],
                      [18, 33.5],
                      [19, 33.5],
                      [20, 33.5],
                      [20, 10],
                      [19, 10],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [19, 10],
                      [18, 10],
                      [18, 51],
                      [19, 51],
                      [20, 51],
                      [20, 10],
                      [19, 10],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0, 0, 0], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 4,
      parent: 1,
    },
    {
      ty: 4,
      nm: "Ellipse 9",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [9.5, 20.5] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: {
          a: 1,
          k: [
            {
              o: { x: 0, y: 0.66 },
              i: { x: 0.66, y: 1 },
              s: [85.5, 70.5],
              t: 0,
            },
            { s: [85.5, 57.5], t: 75 },
          ],
        },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [-4.647, 0],
                      [0, 0],
                      [0, 0],
                      [0, -6.026],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, -5.02],
                      [0, 0],
                      [0, 0],
                      [-5.847, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [0, 10],
                      [1, 10],
                      [9.5, 1],
                      [9.5, 0],
                      [9.5, -1],
                      [-1, 10],
                      [0, 10],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [-4.65, 0],
                      [0, 0],
                      [0, 0],
                      [0, -6.03],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, -5.02],
                      [0, 0],
                      [0, 0],
                      [-5.85, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [0, 10],
                      [1, 10],
                      [9.5, 1],
                      [9.5, 0],
                      [9.5, -1],
                      [-1, 10],
                      [0, 10],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, -5.02],
                      [0, 0],
                      [0, 0],
                      [5.847, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [4.647, 0],
                      [0, 0],
                      [0, 0],
                      [0, -6.026],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [9.5, 0],
                      [9.5, 1],
                      [18, 10],
                      [19, 10],
                      [20, 10],
                      [9.5, -1],
                      [9.5, 0],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, -5.02],
                      [0, 0],
                      [0, 0],
                      [5.85, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [4.65, 0],
                      [0, 0],
                      [0, 0],
                      [0, -6.03],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [9.5, 0],
                      [9.5, 1],
                      [18, 10],
                      [19, 10],
                      [20, 10],
                      [9.5, -1],
                      [9.5, 0],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 0,
            k: {
              c: true,
              i: [
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
              ],
              o: [
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
              ],
              v: [
                [0, 10],
                [-1, 10],
                [-1, 41],
                [0, 41],
                [1, 41],
                [1, 10],
                [0, 10],
              ],
            },
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 0,
            k: {
              c: true,
              i: [
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
              ],
              o: [
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
              ],
              v: [
                [19, 10],
                [18, 10],
                [18, 38.5],
                [19, 38.5],
                [20, 38.5],
                [20, 10],
                [19, 10],
              ],
            },
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0, 0, 0], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 5,
      parent: 1,
    },
    {
      ty: 4,
      nm: "Ellipse 10",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: {
          a: 1,
          k: [
            {
              o: { x: 0, y: 0.66 },
              i: { x: 0.66, y: 1 },
              s: [9.5, 57.75],
              t: 0,
            },
            { s: [9.5, 42], t: 75 },
          ],
        },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: {
          a: 1,
          k: [
            {
              o: { x: 0, y: 0.66 },
              i: { x: 0.66, y: 1 },
              s: [47.5, 57.75],
              t: 0,
            },
            { s: [47.5, 42], t: 75 },
          ],
        },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [-4.647, 0],
                      [0, 0],
                      [0, 0],
                      [0, -6.026],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, -5.02],
                      [0, 0],
                      [0, 0],
                      [-5.847, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [0, 10],
                      [1, 10],
                      [9.5, 1],
                      [9.5, 0],
                      [9.5, -1],
                      [-1, 10],
                      [0, 10],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [-4.79, 0],
                      [0, 0],
                      [0, 0],
                      [0, -5.39],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, -4.11],
                      [0, 0],
                      [0, 0],
                      [-5.7, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [0, 8.6],
                      [1, 8.6],
                      [9.5, 1],
                      [9.5, 0],
                      [9.5, -1],
                      [-1, 8.6],
                      [0, 8.6],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, -5.02],
                      [0, 0],
                      [0, 0],
                      [5.847, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [4.647, 0],
                      [0, 0],
                      [0, 0],
                      [0, -6.026],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [9.5, 0],
                      [9.5, 1],
                      [18, 10],
                      [19, 10],
                      [20, 10],
                      [9.5, -1],
                      [9.5, 0],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, -4.11],
                      [0, 0],
                      [0, 0],
                      [5.7, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [4.79, 0],
                      [0, 0],
                      [0, 0],
                      [0, -5.39],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [9.5, 0],
                      [9.5, 1],
                      [18, 8.6],
                      [19, 8.6],
                      [20, 8.6],
                      [9.5, -1],
                      [9.5, 0],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [0, 10],
                      [-1, 10],
                      [-1, 34.5],
                      [0, 34.5],
                      [1, 34.5],
                      [1, 10],
                      [0, 10],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [0, 8.6],
                      [-1, 8.6],
                      [-1, 29.67],
                      [0, 29.67],
                      [1, 29.67],
                      [1, 8.6],
                      [0, 8.6],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [19, 10],
                      [18, 10],
                      [18, 115.5],
                      [19, 115.5],
                      [20, 115.5],
                      [20, 10],
                      [19, 10],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [19, 8.6],
                      [18, 8.6],
                      [18, 84],
                      [19, 84],
                      [20, 84],
                      [20, 8.6],
                      [19, 8.6],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0, 0, 0], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 6,
      parent: 1,
    },
    {
      ty: 4,
      nm: "Ellipse 6",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [9.5, 17.25] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: {
          a: 1,
          k: [
            {
              o: { x: 0, y: 0.66 },
              i: { x: 0.66, y: 1 },
              s: [9.5, 72.25],
              t: 0,
            },
            { s: [9.5, 42.25], t: 75 },
          ],
        },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [-4.647, 0],
                      [0, 0],
                      [0, 0],
                      [0, -6.026],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, -5.02],
                      [0, 0],
                      [0, 0],
                      [-5.847, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [0, 10],
                      [1, 10],
                      [9.5, 1],
                      [9.5, 0],
                      [9.5, -1],
                      [-1, 10],
                      [0, 10],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [-4.65, 0],
                      [0, 0],
                      [0, 0],
                      [0, -6.03],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, -5.02],
                      [0, 0],
                      [0, 0],
                      [-5.85, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [0, 10],
                      [1, 10],
                      [9.5, 1],
                      [9.5, 0],
                      [9.5, -1],
                      [-1, 10],
                      [0, 10],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, -5.02],
                      [0, 0],
                      [0, 0],
                      [5.847, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [4.647, 0],
                      [0, 0],
                      [0, 0],
                      [0, -6.026],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [9.5, 0],
                      [9.5, 1],
                      [18, 10],
                      [19, 10],
                      [20, 10],
                      [9.5, -1],
                      [9.5, 0],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, -5.02],
                      [0, 0],
                      [0, 0],
                      [5.85, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [4.65, 0],
                      [0, 0],
                      [0, 0],
                      [0, -6.03],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [9.5, 0],
                      [9.5, 1],
                      [18, 10],
                      [19, 10],
                      [20, 10],
                      [9.5, -1],
                      [9.5, 0],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 0,
            k: {
              c: true,
              i: [
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
              ],
              o: [
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
              ],
              v: [
                [0, 10],
                [-1, 10],
                [-1, 34.5],
                [0, 34.5],
                [1, 34.5],
                [1, 10],
                [0, 10],
              ],
            },
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0, 0, 0], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 7,
      parent: 1,
    },
    {
      ty: 4,
      nm: "Group 2713",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [14.75, 39.25] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: {
          a: 1,
          k: [
            {
              o: { x: 0, y: 0.66 },
              i: { x: 0.66, y: 1 },
              s: [150.25, 117.25],
              t: 0,
            },
            { s: [150.25, 132.25], t: 75 },
          ],
        },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [],
      ind: 8,
    },
    {
      ty: 4,
      nm: "Ellipse 2 (Stroke)",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [5.25, 32] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: { a: 0, k: [5.25, 46.5] },
        r: { a: 0, k: -180 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 62.098],
                      [2, 64],
                      [0, 64],
                      [0, 62.098],
                      [2, 62.098],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 62.1],
                      [2, 64],
                      [0, 64],
                      [0, 62.1],
                      [2, 62.1],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 54.489],
                      [2, 58.294],
                      [0, 58.294],
                      [0, 54.489],
                      [2, 54.489],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 54.49],
                      [2, 58.29],
                      [0, 58.29],
                      [0, 54.49],
                      [2, 54.49],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 46.881],
                      [2, 50.685],
                      [0, 50.685],
                      [0, 46.881],
                      [2, 46.881],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 46.88],
                      [2, 50.68],
                      [0, 50.68],
                      [0, 46.88],
                      [2, 46.88],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 39.272],
                      [2, 43.076],
                      [0, 43.076],
                      [0, 39.272],
                      [2, 39.272],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 39.27],
                      [2, 43.08],
                      [0, 43.08],
                      [0, 39.27],
                      [2, 39.27],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 31.663],
                      [2, 35.468],
                      [0, 35.468],
                      [0, 31.663],
                      [2, 31.663],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 31.66],
                      [2, 35.47],
                      [0, 35.47],
                      [0, 31.66],
                      [2, 31.66],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 24.055],
                      [2, 27.858],
                      [0, 27.858],
                      [0, 24.055],
                      [2, 24.055],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 24.05],
                      [2, 27.86],
                      [0, 27.86],
                      [0, 24.05],
                      [2, 24.05],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 16.445],
                      [2, 20.25],
                      [0, 20.25],
                      [0, 16.445],
                      [2, 16.445],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 16.45],
                      [2, 20.25],
                      [0, 20.25],
                      [0, 16.45],
                      [2, 16.45],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.128, 0.669],
                      [0, 0],
                      [0, -0.579],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, -0.706],
                      [0, 0],
                      [-0.104, 0.546],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [0, 10.739],
                      [0.194, 8.674],
                      [2.159, 9.048],
                      [2, 10.739],
                      [2, 12.642],
                      [0, 12.642],
                      [0, 10.739],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.13, 0.67],
                      [0, 0],
                      [0, -0.58],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, -0.71],
                      [0, 0],
                      [-0.1, 0.55],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [0, 10.74],
                      [0.19, 8.67],
                      [2.16, 9.05],
                      [2, 10.74],
                      [2, 12.64],
                      [0, 12.64],
                      [0, 10.74],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0.618, -0.957],
                      [0, 0],
                      [-1.14, 0.792],
                    ],
                    o: [
                      [0, 0],
                      [-0.923, 0.642],
                      [0, 0],
                      [0.758, -1.175],
                      [0, 0],
                    ],
                    v: [
                      [4.605, 1.851],
                      [5.747, 3.493],
                      [3.41, 5.916],
                      [1.729, 4.832],
                      [4.605, 1.851],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0.62, -0.96],
                      [0, 0],
                      [-1.14, 0.79],
                    ],
                    o: [
                      [0, 0],
                      [-0.92, 0.64],
                      [0, 0],
                      [0.76, -1.17],
                      [0, 0],
                    ],
                    v: [
                      [4.61, 1.85],
                      [5.75, 3.49],
                      [3.41, 5.92],
                      [1.73, 4.83],
                      [4.61, 1.85],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0.541, -0.111],
                      [0, 0],
                      [0, 0],
                      [-0.71, 0],
                    ],
                    o: [
                      [0, 0],
                      [-0.574, 0],
                      [0, 0],
                      [0, 0],
                      [0.672, -0.138],
                      [0, 0],
                    ],
                    v: [
                      [10.5, 0],
                      [10.5, 2],
                      [8.825, 2.17],
                      [8.623, 1.19],
                      [8.422, 0.21],
                      [10.5, 0],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0.54, -0.11],
                      [0, 0],
                      [0, 0],
                      [-0.71, 0],
                    ],
                    o: [
                      [0, 0],
                      [-0.57, 0],
                      [0, 0],
                      [0, 0],
                      [0.67, -0.14],
                      [0, 0],
                    ],
                    v: [
                      [10.5, 0],
                      [10.5, 2],
                      [8.83, 2.17],
                      [8.62, 1.19],
                      [8.42, 0.21],
                      [10.5, 0],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0, 0, 0], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 9,
      parent: 8,
    },
    {
      ty: 4,
      nm: "Ellipse 3 (Stroke)",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [10.5, 14.5] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: { a: 0, k: [19, 14.5] },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [21, 26.718],
                      [21, 29],
                      [19, 29],
                      [19, 26.718],
                      [21, 26.718],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [21, 26.72],
                      [21, 29],
                      [19, 29],
                      [19, 26.72],
                      [21, 26.72],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [21, 17.587],
                      [21, 22.152],
                      [19, 22.152],
                      [19, 17.587],
                      [21, 17.587],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [21, 17.59],
                      [21, 22.15],
                      [19, 22.15],
                      [19, 17.59],
                      [21, 17.59],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 13.56],
                      [2, 14.5],
                      [0, 14.5],
                      [0, 13.56],
                      [2, 13.56],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 13.56],
                      [2, 14.5],
                      [0, 14.5],
                      [0, 13.56],
                      [2, 13.56],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0.104, 0.546],
                      [0, 0],
                      [0, -0.706],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, -0.579],
                      [0, 0],
                      [0.127, 0.669],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [19, 10.739],
                      [18.841, 9.048],
                      [20.806, 8.674],
                      [21, 10.739],
                      [21, 13.022],
                      [19, 13.022],
                      [19, 10.739],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0.1, 0.55],
                      [0, 0],
                      [0, -0.71],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, -0.58],
                      [0, 0],
                      [0.13, 0.67],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [19, 10.74],
                      [18.84, 9.05],
                      [20.81, 8.67],
                      [21, 10.74],
                      [21, 13.02],
                      [19, 13.02],
                      [19, 10.74],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.128, 0.669],
                      [0, 0],
                      [0, -0.579],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, -0.706],
                      [0, 0],
                      [-0.104, 0.546],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [0, 10.739],
                      [0.194, 8.674],
                      [2.159, 9.048],
                      [2, 10.739],
                      [2, 11.68],
                      [0, 11.68],
                      [0, 10.739],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.13, 0.67],
                      [0, 0],
                      [0, -0.58],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, -0.71],
                      [0, 0],
                      [-0.1, 0.55],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [0, 10.74],
                      [0.19, 8.67],
                      [2.16, 9.05],
                      [2, 10.74],
                      [2, 11.68],
                      [0, 11.68],
                      [0, 10.74],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0.618, -0.957],
                      [0, 0],
                      [-1.14, 0.792],
                    ],
                    o: [
                      [0, 0],
                      [-0.923, 0.642],
                      [0, 0],
                      [0.758, -1.175],
                      [0, 0],
                    ],
                    v: [
                      [4.605, 1.851],
                      [5.747, 3.493],
                      [3.41, 5.916],
                      [1.729, 4.832],
                      [4.605, 1.851],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0.62, -0.96],
                      [0, 0],
                      [-1.14, 0.79],
                    ],
                    o: [
                      [0, 0],
                      [-0.92, 0.64],
                      [0, 0],
                      [0.76, -1.17],
                      [0, 0],
                    ],
                    v: [
                      [4.61, 1.85],
                      [5.75, 3.49],
                      [3.41, 5.92],
                      [1.73, 4.83],
                      [4.61, 1.85],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.758, -1.175],
                      [0, 0],
                      [0.923, 0.642],
                      [0, 0],
                    ],
                    o: [
                      [1.14, 0.792],
                      [0, 0],
                      [-0.617, -0.957],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [16.395, 1.851],
                      [19.271, 4.832],
                      [17.59, 5.916],
                      [15.253, 3.493],
                      [16.395, 1.851],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.76, -1.17],
                      [0, 0],
                      [0.92, 0.64],
                      [0, 0],
                    ],
                    o: [
                      [1.14, 0.79],
                      [0, 0],
                      [-0.62, -0.96],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [16.39, 1.85],
                      [19.27, 4.83],
                      [17.59, 5.92],
                      [15.25, 3.49],
                      [16.39, 1.85],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.672, -0.138],
                      [0, 0],
                      [0, 0],
                      [0.574, 0],
                      [0.541, -0.111],
                      [0, 0],
                      [0, 0],
                      [-0.71, 0],
                    ],
                    o: [
                      [0.71, 0],
                      [0, 0],
                      [0, 0],
                      [-0.541, -0.111],
                      [-0.574, 0],
                      [0, 0],
                      [0, 0],
                      [0.672, -0.138],
                      [0, 0],
                    ],
                    v: [
                      [10.5, 0],
                      [12.578, 0.21],
                      [12.377, 1.19],
                      [12.175, 2.17],
                      [10.5, 2],
                      [8.825, 2.17],
                      [8.623, 1.19],
                      [8.422, 0.21],
                      [10.5, 0],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.67, -0.14],
                      [0, 0],
                      [0, 0],
                      [0.57, 0],
                      [0.54, -0.11],
                      [0, 0],
                      [0, 0],
                      [-0.71, 0],
                    ],
                    o: [
                      [0.71, 0],
                      [0, 0],
                      [0, 0],
                      [-0.54, -0.11],
                      [-0.57, 0],
                      [0, 0],
                      [0, 0],
                      [0.67, -0.14],
                      [0, 0],
                    ],
                    v: [
                      [10.5, 0],
                      [12.58, 0.21],
                      [12.38, 1.19],
                      [12.17, 2.17],
                      [10.5, 2],
                      [8.83, 2.17],
                      [8.62, 1.19],
                      [8.42, 0.21],
                      [10.5, 0],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0, 0, 0], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 10,
      parent: 8,
    },
    {
      ty: 4,
      nm: "Ellipse 5 (Stroke)",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [10.5, 24.75] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: {
          a: 1,
          k: [
            {
              o: { x: 0, y: 0.66 },
              i: { x: 0.66, y: 1 },
              s: [192.5, 129.75],
              t: 0,
            },
            { s: [192.5, 144.75], t: 75 },
          ],
        },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 47.562],
                      [2, 49.5],
                      [0, 49.5],
                      [0, 47.562],
                      [2, 47.562],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 47.56],
                      [2, 49.5],
                      [0, 49.5],
                      [0, 47.56],
                      [2, 47.56],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 39.81],
                      [2, 43.686],
                      [0, 43.686],
                      [0, 39.81],
                      [2, 39.81],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 39.81],
                      [2, 43.69],
                      [0, 43.69],
                      [0, 39.81],
                      [2, 39.81],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 32.058],
                      [2, 35.934],
                      [0, 35.934],
                      [0, 32.058],
                      [2, 32.058],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 32.06],
                      [2, 35.93],
                      [0, 35.93],
                      [0, 32.06],
                      [2, 32.06],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [21, 33.437],
                      [21, 35.5],
                      [19, 35.5],
                      [19, 33.437],
                      [21, 33.437],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [21, 33.44],
                      [21, 35.5],
                      [19, 35.5],
                      [19, 33.44],
                      [21, 33.44],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [21, 25.183],
                      [21, 29.31],
                      [19, 29.31],
                      [19, 25.183],
                      [21, 25.183],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [21, 25.18],
                      [21, 29.31],
                      [19, 29.31],
                      [19, 25.18],
                      [21, 25.18],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 24.306],
                      [2, 28.182],
                      [0, 28.182],
                      [0, 24.306],
                      [2, 24.306],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 24.31],
                      [2, 28.18],
                      [0, 28.18],
                      [0, 24.31],
                      [2, 24.31],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [21, 16.93],
                      [21, 21.057],
                      [19, 21.057],
                      [19, 16.93],
                      [21, 16.93],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [21, 16.93],
                      [21, 21.06],
                      [19, 21.06],
                      [19, 16.93],
                      [21, 16.93],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 16.554],
                      [2, 20.43],
                      [0, 20.43],
                      [0, 16.554],
                      [2, 16.554],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 16.55],
                      [2, 20.43],
                      [0, 20.43],
                      [0, 16.55],
                      [2, 16.55],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0.104, 0.546],
                      [0, 0],
                      [0, -0.706],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, -0.579],
                      [0, 0],
                      [0.127, 0.669],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [19, 10.739],
                      [18.841, 9.048],
                      [20.806, 8.674],
                      [21, 10.739],
                      [21, 12.803],
                      [19, 12.803],
                      [19, 10.739],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0.1, 0.55],
                      [0, 0],
                      [0, -0.71],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, -0.58],
                      [0, 0],
                      [0.13, 0.67],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [19, 10.74],
                      [18.84, 9.05],
                      [20.81, 8.67],
                      [21, 10.74],
                      [21, 12.8],
                      [19, 12.8],
                      [19, 10.74],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.128, 0.669],
                      [0, 0],
                      [0, -0.579],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, -0.706],
                      [0, 0],
                      [-0.104, 0.546],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [0, 10.739],
                      [0.194, 8.674],
                      [2.159, 9.048],
                      [2, 10.739],
                      [2, 12.677],
                      [0, 12.677],
                      [0, 10.739],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.13, 0.67],
                      [0, 0],
                      [0, -0.58],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, -0.71],
                      [0, 0],
                      [-0.1, 0.55],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [0, 10.74],
                      [0.19, 8.67],
                      [2.16, 9.05],
                      [2, 10.74],
                      [2, 12.68],
                      [0, 12.68],
                      [0, 10.74],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0.618, -0.957],
                      [0, 0],
                      [-1.14, 0.792],
                    ],
                    o: [
                      [0, 0],
                      [-0.923, 0.642],
                      [0, 0],
                      [0.758, -1.175],
                      [0, 0],
                    ],
                    v: [
                      [4.605, 1.851],
                      [5.747, 3.493],
                      [3.41, 5.916],
                      [1.729, 4.832],
                      [4.605, 1.851],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0.62, -0.96],
                      [0, 0],
                      [-1.14, 0.79],
                    ],
                    o: [
                      [0, 0],
                      [-0.92, 0.64],
                      [0, 0],
                      [0.76, -1.17],
                      [0, 0],
                    ],
                    v: [
                      [4.61, 1.85],
                      [5.75, 3.49],
                      [3.41, 5.92],
                      [1.73, 4.83],
                      [4.61, 1.85],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.758, -1.175],
                      [0, 0],
                      [0.923, 0.642],
                      [0, 0],
                    ],
                    o: [
                      [1.14, 0.792],
                      [0, 0],
                      [-0.617, -0.957],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [16.395, 1.851],
                      [19.271, 4.832],
                      [17.59, 5.916],
                      [15.253, 3.493],
                      [16.395, 1.851],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.76, -1.17],
                      [0, 0],
                      [0.92, 0.64],
                      [0, 0],
                    ],
                    o: [
                      [1.14, 0.79],
                      [0, 0],
                      [-0.62, -0.96],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [16.39, 1.85],
                      [19.27, 4.83],
                      [17.59, 5.92],
                      [15.25, 3.49],
                      [16.39, 1.85],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.672, -0.138],
                      [0, 0],
                      [0, 0],
                      [0.574, 0],
                      [0.541, -0.111],
                      [0, 0],
                      [0, 0],
                      [-0.71, 0],
                    ],
                    o: [
                      [0.71, 0],
                      [0, 0],
                      [0, 0],
                      [-0.541, -0.111],
                      [-0.574, 0],
                      [0, 0],
                      [0, 0],
                      [0.672, -0.138],
                      [0, 0],
                    ],
                    v: [
                      [10.5, 0],
                      [12.578, 0.21],
                      [12.377, 1.19],
                      [12.175, 2.17],
                      [10.5, 2],
                      [8.825, 2.17],
                      [8.623, 1.19],
                      [8.422, 0.21],
                      [10.5, 0],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.67, -0.14],
                      [0, 0],
                      [0, 0],
                      [0.57, 0],
                      [0.54, -0.11],
                      [0, 0],
                      [0, 0],
                      [-0.71, 0],
                    ],
                    o: [
                      [0.71, 0],
                      [0, 0],
                      [0, 0],
                      [-0.54, -0.11],
                      [-0.57, 0],
                      [0, 0],
                      [0, 0],
                      [0.67, -0.14],
                      [0, 0],
                    ],
                    v: [
                      [10.5, 0],
                      [12.58, 0.21],
                      [12.38, 1.19],
                      [12.17, 2.17],
                      [10.5, 2],
                      [8.83, 2.17],
                      [8.62, 1.19],
                      [8.42, 0.21],
                      [10.5, 0],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0, 0, 0], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 11,
    },
    {
      ty: 4,
      nm: "Ellipse 1 (Stroke)",
      sr: 1,
      st: 0,
      op: 76.01,
      ip: 0,
      hasMask: false,
      ao: 0,
      ks: {
        a: { a: 0, k: [5.25, 16.5] },
        s: { a: 0, k: [100, 100] },
        sk: { a: 0, k: 0 },
        p: {
          a: 1,
          k: [
            {
              o: { x: 0, y: 0.66 },
              i: { x: 0.66, y: 1 },
              s: [111.25, 126.5],
              t: 0,
            },
            { s: [111.25, 115.5], t: 75 },
          ],
        },
        r: { a: 0, k: 0 },
        sa: { a: 0, k: 0 },
        o: { a: 0, k: 100 },
      },
      shapes: [
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 31.145],
                      [2, 33],
                      [0, 33],
                      [0, 31.145],
                      [2, 31.145],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 31.14],
                      [2, 33],
                      [0, 33],
                      [0, 31.14],
                      [2, 31.14],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 23.725],
                      [2, 27.435],
                      [0, 27.435],
                      [0, 23.725],
                      [2, 23.725],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 23.72],
                      [2, 27.43],
                      [0, 27.43],
                      [0, 23.72],
                      [2, 23.72],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 16.305],
                      [2, 20.015],
                      [0, 20.015],
                      [0, 16.305],
                      [2, 16.305],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2, 16.3],
                      [2, 20.01],
                      [0, 20.01],
                      [0, 16.3],
                      [2, 16.3],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.128, 0.669],
                      [0, 0],
                      [0, -0.579],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, -0.706],
                      [0, 0],
                      [-0.104, 0.546],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [0, 10.739],
                      [0.194, 8.674],
                      [2.159, 9.048],
                      [2, 10.739],
                      [2, 12.594],
                      [0, 12.594],
                      [0, 10.739],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [-0.13, 0.67],
                      [0, 0],
                      [0, -0.58],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, -0.71],
                      [0, 0],
                      [-0.1, 0.55],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [0, 10.74],
                      [0.19, 8.67],
                      [2.16, 9.05],
                      [2, 10.74],
                      [2, 12.59],
                      [0, 12.59],
                      [0, 10.74],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0.618, -0.957],
                      [0, 0],
                      [-1.14, 0.792],
                    ],
                    o: [
                      [0, 0],
                      [-0.923, 0.642],
                      [0, 0],
                      [0.758, -1.175],
                      [0, 0],
                    ],
                    v: [
                      [4.605, 1.851],
                      [5.747, 3.493],
                      [3.41, 5.916],
                      [1.729, 4.832],
                      [4.605, 1.851],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0.62, -0.96],
                      [0, 0],
                      [-1.14, 0.79],
                    ],
                    o: [
                      [0, 0],
                      [-0.92, 0.64],
                      [0, 0],
                      [0.76, -1.17],
                      [0, 0],
                    ],
                    v: [
                      [4.61, 1.85],
                      [5.75, 3.49],
                      [3.41, 5.92],
                      [1.73, 4.83],
                      [4.61, 1.85],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "sh",
          nm: "",
          d: 1,
          ks: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0.541, -0.111],
                      [0, 0],
                      [0, 0],
                      [-0.71, 0],
                    ],
                    o: [
                      [0, 0],
                      [-0.574, 0],
                      [0, 0],
                      [0, 0],
                      [0.672, -0.138],
                      [0, 0],
                    ],
                    v: [
                      [10.5, 0],
                      [10.5, 2],
                      [8.825, 2.17],
                      [8.623, 1.19],
                      [8.422, 0.21],
                      [10.5, 0],
                    ],
                  },
                ],
                t: 0,
              },
              {
                s: [
                  {
                    c: true,
                    i: [
                      [0, 0],
                      [0, 0],
                      [0.54, -0.11],
                      [0, 0],
                      [0, 0],
                      [-0.71, 0],
                    ],
                    o: [
                      [0, 0],
                      [-0.57, 0],
                      [0, 0],
                      [0, 0],
                      [0.67, -0.14],
                      [0, 0],
                    ],
                    v: [
                      [10.5, 0],
                      [10.5, 2],
                      [8.83, 2.17],
                      [8.62, 1.19],
                      [8.42, 0.21],
                      [10.5, 0],
                    ],
                  },
                ],
                t: 75,
              },
            ],
          },
        },
        {
          ty: "fl",
          nm: "",
          c: {
            a: 1,
            k: [
              {
                o: { x: 0, y: 0.66 },
                i: { x: 0.66, y: 1 },
                s: [1, 1, 1],
                t: 0,
              },
              { s: [0, 0, 0], t: 75 },
            ],
          },
          r: 1,
          o: { a: 0, k: 100 },
        },
      ],
      ind: 12,
    },
  ],
  v: "5.7.0",
  fr: 60,
  op: 75.01,
  ip: 0,
  assets: [],
};
